module.exports = __webpack_public_path__ + "static/n5_logo_transparent-6622c9d9a6fc4d17aaf0e2281f5afa02.png";